import $ from "jquery";
import "../bootstrap/fmg/js/bootstrap.min.js";
import {activePickerItem, GPContextItems} from "./gp-context-items.js";
import {fontSize, GPContextLabels} from "./gp-context-labels.js";
import {GPPlant} from "./gp-plant.js";
import {GPStructure} from "./gp-structure.js";
import {GPCustomObject} from "./gp-customobject.js";
import {GPProjectView} from "./gp-projectview.js";
import {GPProject} from "./gp-project.js";
import {GPBackground} from "./gp-typebackground.js";
import {GPTexture} from "./gp-typetexture.js";
import {GPTutorial} from "./gp-tutorial.js";
import {GPLabel} from "./gp-label.js";
import {GPStructure3D} from "./gp-structure3d";
import {GPMisc} from "./gp-misc";
import { get, writable } from 'svelte/store';
import {GPContextTexture} from "./gp-context-texture";
import {GPTypePlant} from "./gp-typeplant";
import {GPTypeStructure} from "./gp-typestructure";
import {GPTypeStructure3d} from "./gp-typestructure3d";
import {GPTypeCustomStructure} from "./gp-typecustomstructure";
import {GPTypeSnippet} from "./gp-typesnippet";
import GPPrintTemplate from "./gp-print-template.svelte";
import GPShareByEmail from "./gp-share-by-email.svelte";

export let soilSettings = writable({});
export let season = writable("l");
export let lightDirection = writable(1);
export let preferredNames = writable("default");
export let mode = writable("");
export let showLabels = writable(true);
export let magic = writable(false);
/**
 *
 * @type {Writable<[GPItem]>}
 */
export let selectedItemSet = writable([]);
export let app = writable();
export let customStore = writable([]);
export let snippetsStore = writable([]);
export let modeOffline = writable(true);
export let undoAvailable = writable(true);
export let overwriteOnlineAvailable = writable(false);
export let overwriteOnlineName = writable("");
export let overwriteFileAvailable = writable(false);
export let unsavedChanges = writable(false);
export let pasteAvailable = writable(false);

export let GP = {
    version: document.querySelector("meta[property='gp:version']").getAttribute('content'),
    data: null,

    /**
     * @member [GPTypePlant]
     */
    plantTypes: null,
    /**
     * @member {Object.<int, GPTypePlant>}
     */
    plantTypesById: {},
    /**
     * @member [GPTypeStructure]
     */
    structureTypes: null,
    /**
     * @member {Object.<int, GPTypeStructure>}
     */
    structureTypesById: {},
    backgrounds: null,
    backgroundsById: {},
    textures: null,
    texturesById: {},
    customObjects: [], //these are users objects, available in picker
    customObjectsById: {},
    snippets: null,
    project: null,
    undoStack: [],
    waitIndicator: false,
    nextFocus: null,
    viewZoom: 1,
    cloningOffset: 10,

    app: null,


    preinit: function() {
        GP.init();
        GP.app = get(app);
    },

    init: function () {
        GP.resetUndo();
        GP.updatePastePossible();

        $('.version-note').text(GP.version);

        if (GP.getParameterByName("username")) GPSettings.storageClass.onlineAppEmail = GP.getParameterByName("username");

        if (!GPSettings.keyShortcutsNative) {
            document.addEventListener('keydown', (e) => {
                //undo
                if (e.key == "z" && (e.ctrlKey || e.metaKey)) {
                    GP.undo();
                }
                if (e.key == "a" && (e.ctrlKey || e.metaKey)) {
                    GP.selectAllItems();
                }
            })
        }

        GP.preloaderSetProgress(10);
        GPSettings.initSettings().then(GP.initApp);
    },


    initApp: function () {
        mode.set("");
        GP.preloaderSetProgress(30);
        Promise.all([
            $.ajax({
                dataType: "json",
                url: GPSettings.assetsAddr
              }),
            GP.loadSnippets()
        ]).then(GP.dataLoaded)
    },

    setProject: function (prj) {
        GP.project = prj;
        overwriteOnlineAvailable.set(GP.project.savedId);
        overwriteFileAvailable.set(GP.project.savedPath || GP.project.savedIOSId);
        overwriteOnlineName.set(GP.project.title ? GP.project.title : "");
        unsavedChanges.set(GP.project.unsavedChanges);
    },

    loadSnippets: function () {
        return new Promise((resolve, reject) => {
            $.ajax({
                dataType: "json",
                url: GPSettings.servicesAddr + "/getProjectSnippets",
                data: {
                    token: GPSettings.storageClass.token,
                    email: GPSettings.storageClass.onlineAppEmail
                },
                success: resolve,
                error: () => resolve()
            })
        })
    },
    
    dataLoaded: function (resArr) {
        GP.preloaderSetProgress(50);
        GP.processData(resArr[0].data);
        if (resArr[1])
            GP.processSnippets(resArr[1]);

        var startupProjectId = GP.getParameterByName("openProject");
        var startupProjectPath = GP.getParameterByName("openProjectPath");

        if (startupProjectId) {
            GP.userProjectLoadDetails(startupProjectId).then(GP.initAppPhase2);
        } else if (startupProjectPath) {
            (async () => {
                let file = await GPMisc.createFileFromPath(startupProjectPath);
                GPSettings.storageClass.loadProjectFromFile(file).then(GP.readProject).then(GP.initAppPhase2);
            })()
        } else {
            GP.setProject(new GPProject(GPSettings.defaultBackgroundId));
            GPProjectView.initNew().then(GP.initAppPhase2);
        }
    },

    initAppPhase2: function() {
        GP.preloaderSetProgress(80);

        GP.refreshUndo();
        GP.updateHtmlClasses();

        mode.subscribe(() => selectedItemSet.set([]));
        mode.set("Plants");

        selectedItemSet.subscribe(() => GP.cloningOffset = 10);

        if ($('.preload'))
            GP.preloaderHide()

        if (localStorage['gptutorialdone'] === "1" && !GPSettings.products.custom_background.active && GPSettings.storageClass.signupDate && (Date.now() - GPSettings.storageClass.signupDate) > 3 * 24 * 60 * 60 * 1000) {
            GPSettings.upgradeClass.showOnlyInPremium("general");
        }
    },
    
    updateHtmlClasses: function() {
        var allProductsPurchased = true;
        Object.keys(GPSettings.products).forEach(function(key,index) {
            $("html").removeClass("GPProdActive_"+key);
            $("html").removeClass("GPProdInactive_"+key);
            if (GPSettings.products[key].active)
                $("html").addClass("GPProdActive_"+key);
            else {
                $("html").addClass("GPProdInactive_"+key);
                allProductsPurchased = false;
            }
        });
        if (allProductsPurchased)
            $("html").addClass("GPProd_allProductsPurchased");
        else
            $("html").removeClass("GPProd_allProductsPurchased");
        
        if (!GPSettings.storageClass.onlineAppEmail && GPSettings.servicesProtocol !== "gpjs://" && GPSettings.servicesProtocol !== "electron") {
            $("html").addClass("GPStorageDisabled");
            $(".GPOpenButton, .GPSaveButton").remove();
        } else
            $("html").removeClass("GPStorageDisabled");
        
    },
    
    processData: function(data) {
        GP.plantTypes = [];
        for (let i in data.plants.p) {
            let gpt = data.plants.p[i];
            let pt = new GPTypePlant(gpt);
            GP.plantTypes.push(pt);
            GP.plantTypesById[pt.id] = pt;
        }
        
        GP.backgrounds = [];
        for (let i in data.backgrounds.background) {
            let b = data.backgrounds.background[i];
            let bt = new GPBackground(b);
            GP.backgrounds.push(bt);
            GP.backgroundsById[bt.id] = bt;
        }
        GP.backgrounds.sort(function(a, b) {
            return a.ord - b.ord;
        });

        GP.textures = [];
        for (let i in data.textures.texture) {
            let gtt = data.textures.texture[i];
            let tt = new GPTexture(gtt);
            GP.textures.push(tt);
            GP.texturesById[tt.id] = tt;
        }

        GP.structureTypes = [];
        for (let i in data.equipments.equipment) {
            let gst = data.equipments.equipment[i];
            let st;
            if (gst['model3d'])
                st = new GPTypeStructure3d(gst);
            else
                st = new GPTypeStructure(gst);
            GP.structureTypes.push(st);
            GP.structureTypesById[st.id] = st;
        }
    },

    processSnippets: function(data) {
        GP.snippets = [];
        data.forEach(el => {
            let st = new GPTypeSnippet(el);
            GP.snippets.push(st);
        });
        snippetsStore.set(GP.snippets);
        modeOffline.set(false);
    },
    
    processCustomObjects: function(data) {
        GP.customObjects = [];

        data.customObject.forEach((el) => {
            let st = new GPTypeCustomStructure(el);
            GP.customObjects.push(st);
            GP.customObjectsById[st.id] = st;
        })

        customStore.set(GP.customObjects);
    },

    addLabel: function(originItemInstance, text) {
        var label = GP.project.addLabel(originItemInstance, text, originItemInstance.x, originItemInstance.y);
        GPContextLabels.addLabelToView(label);
        GP.saveUndo("addItem", label);

        return label;
    },

    updateLabel: function(label, text) {
        GP.saveUndo("modifyItems", [label]);
        label.text = text;
        GPContextLabels.addLabelToView(label);

        return label;
    },

    removeLabel: function(item) {
        GP.saveUndo("deleteItems", [{itemInstance: item, type: item.constructor.name}]);
        GP.project.removeItem(item.id);
    },

    generateJPGImage: function (w,h) {
        if (!h) h = Math.floor(GP.project.sizeY * w / GP.project.sizeX);

        var orgZoom = GP.viewZoom;
        GP.viewZoom *= w / $('#GPProjectView').innerWidth();
        if (h/60 > fontSize)
            GPContextLabels.resizeLabels((h/60) / fontSize);

        GPProjectView.onresize();
        GPProjectView.stage.draw();

        var can1 = $("#GPProjectView canvas")[0];
        var can2 = $("#GPProjectView canvas")[1];
        var can3 = $("#GPProjectView canvas")[2];

        let can5 = document.createElement('canvas');
        can5.style.display = "none";

        can5.width = w;
        can5.height = h;
        var ctx5 = can5.getContext('2d');

        ctx5.drawImage(can1, 0, 0, can1.width, can1.height, 0, 0, w, h);
        ctx5.drawImage(can2, 0, 0, can1.width, can1.height, 0, 0, w, h);
        ctx5.drawImage(can3, 0, 0, can1.width, can1.height, 0, 0, w, h);

        let data = can5.toDataURL('image/jpeg', 0.7);

        GP.viewZoom = orgZoom;
        GPContextLabels.resizeLabels( 1 );
        GPProjectView.onresize();
        
        return data;
    },

    generatePNGImage: function (w) {
        let orgZoom = GP.viewZoom;

        let can3 = $("#GPProjectView canvas")[2];
        let ctx3 = can3.getContext('2d');
        let bounds = GPMisc.getContentBounds(ctx3, can3.width, can3.height);
        let cutWidth = bounds[2] - bounds[0];
        let cutHeight = bounds[3] - bounds[1];

        let can6 = document.createElement('canvas');
        can6.width = w;
        can6.height = Math.floor(cutHeight * w / cutWidth)
        let ctx6 = can6.getContext('2d');

        let scaleFactor = w / cutWidth;

        GP.viewZoom *= scaleFactor;
        GPProjectView.onresize();
        GPProjectView.stage.draw();

        ctx6.drawImage(can3, bounds[0]*scaleFactor, bounds[1]*scaleFactor, cutWidth*scaleFactor, cutHeight*scaleFactor, 0, 0, w, can6.height);
        let data = can6.toDataURL('image/webp');

        GP.viewZoom = orgZoom;
        GPProjectView.onresize();

        return data;
    },

    preparePrintImage: function () {
        return GP.generateJPGImage(GP.project.sizeX, GP.project.sizeY);
    },

    prepareSaveThumbnailImage: function () {
        var data = GP.generateJPGImage(GPSettings.thumbSaveWidth);
        var output=data.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
        return output;
    },

    downloadImageHandler: function() {
        GPSettings.storageClass.exportJPG(GP.preparePrintImage());
    },
    
    prepareSnippetPrev: function() {
        GPProjectView.snippetOnlyViewOn();
        GPProjectView.stage.draw();
        let data = GP.generatePNGImage(500);
        GPProjectView.snippetOnlyViewOff();
        return data;
    },

    selectedItemsToSnippetData: function() {
        return JSON.stringify(get(selectedItemSet).filter(el => el instanceof GPPlant).map( si => {return {itemInstance: si}} ))
    },

    saveSnippet: function() {
        GP.app.showSaveSnippet();
    },

    printProjectView: function() {
        let dataUrl = GP.preparePrintImage();

        let printWin = window.open('','','width='+GP.project.sizeX+',height='+GP.project.sizeY);
        let container = printWin.document.createElement('div');
        printWin.document.body.appendChild(container);
        new GPPrintTemplate({
            target: container,
            props: {
                imgDataUrl : dataUrl,
                items : GP.project.plantTypes(),
                printFunc: () => {
                    printWin.print();
                    printWin.close();
                }
            }});
    },

    shareByEmail: function() {
        let component = new GPShareByEmail({
            target: document.body,
            props: {
                project: GP.project
            }
        });
        component.showForm();
    },

    desktopPrintProjectView: function() {
        let dataUrl = GP.preparePrintImage();

        let printWin = window.open('','','width='+GP.project.sizeX+',height='+GP.project.sizeY);
        let container = printWin.document.createElement('div');
        printWin.document.body.appendChild(container);
        new GPPrintTemplate({
            target: container,
            props: {
                imgDataUrl : dataUrl,
                items : GP.project.plantTypes(),
                printFunc: () => {
                    printWin.print();
                    printWin.close();
                }
            }});
        let html = printWin.document.documentElement.outerHTML;
        //GPSettings.printHTMLWindow(html);
    },
    
    newProject: function() {
        delete GP.project;
        GP.setProject (new GPProject(GPSettings.defaultBackgroundId));
        GPProjectView.initNew();
        GP.resetUndo();
        selectedItemSet.set([]);

        if (get(mode) === "Plants")
            GPContextItems.activate();
        else
            mode.set("Plants");

        $('#GPProjectView').focus();
        let evt = new CustomEvent('GPNewProject', {});
        window.dispatchEvent(evt);
    },

    startOver: function() {
        let newProject = new GPProject(null, GP.project);
        delete GP.project;
        GP.setProject (newProject);
        GPProjectView.initNew();
        GP.resetUndo();
        selectedItemSet.set([]);

        if (get(mode) === "Plants")
            GPContextItems.activate();
        else
            mode.set("Plants");

        $('#GPProjectView').focus();
        let evt = new CustomEvent('GPNewProject', {});
        window.dispatchEvent(evt);
    },

    changeBackground: function(backgroundId) {
        GP.setProject( new GPProject(backgroundId));
        GPProjectView.initNew();
        GP.resetUndo();
        selectedItemSet.set([]);

        if (get(mode) === "Plants")
            GPContextItems.activate();
        else
            mode.set("Plants");

        $('#GPProjectView').focus();
        let evt = new CustomEvent('GPNewProject', {});
        window.dispatchEvent(evt);
    },
    
    GPUploadBackground: function () {
        if (GPSettings.products.custom_background.active)
            GPSettings.storageClass.getCustomBackgroundImage().then(GP.app.showCalibrator);
        else
            GPSettings.upgradeClass.showOnlyInPremium("custombg");
    },
        
    loadImageAsBackground: function(uri, horizonPos, designWidth) {

        //TODO: Refactor, loaded only for getting size?
        var imageObj = new Image;
        $(imageObj).one('load', function () {
            GP.setProject( new GPProject(null, null, uri, horizonPos, designWidth, imageObj.width, imageObj.height));
            GPProjectView.initNew();
            GP.resetUndo();
            selectedItemSet.set([]);

            if (get(mode) === "Plants")
                GPContextItems.activate();
            else
                mode.set("Plants");

            $('#GPProjectView').focus();
            let evt = new CustomEvent('GPNewProject', {});
            window.dispatchEvent(evt);
        });
        imageObj.src = uri;
    },

    GPUploadCustomObject: function () {
        GPMisc.askForFile('image/jpeg,image/png,image/heic,image/webp').then(GPMisc.loadImageFile).then(GP.app.showUploadCustomObject);
    },

    userProjectLoadDetails: function(projId) {
        GP.showWaiting();

        return GPSettings.storageClass.loadOnlineProjectDetails(projId).then(function(res){return GP.readProject(res,projId)});
    },

    handleFileDrop: function(e) {
        if(e.dataTransfer && e.dataTransfer.files.length) {
            e.preventDefault();
            e.stopPropagation();
            var f = e.dataTransfer.files[0];
            if (f.type === "image/jpeg" || f.type === "image/webp" || f.type === "image/heic") {
                if (GPSettings.products.custom_background.active)
                    GP.app.unsavedChangesWarning(function () {
                        GPMisc.loadImageFile(f).then(GP.app.showCalibrator);
                    });
                else
                    GPSettings.upgradeClass.showOnlyInPremium("custombg");
            }
            else
            if (f.name.match(/(\.prj$)/i))
                GP.app.unsavedChangesWarning(function() {
                    GPSettings.storageClass.loadProjectFromFile(f).then(GP.readProject)
                });
        }
    },

    /*
    handleCustomObjectAreaFileDrop: function(e) {
        if(e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files.length) {
            e.preventDefault();
            e.stopPropagation();
            var f = e.originalEvent.dataTransfer.files[0];
            GPMisc.loadImageFile(f).then(GP.showUploadCustomObject);
        }
    },*/

    /**
     *
     * @param {json} prjJson
     * @return {Promise<unknown>}
     */
    readProject: function (prjJson) {
        return new Promise(function(resolve, reject) {
            let prj = GPProject.parseFromJson(prjJson, {"mode": "load"});
            if (prj) {
                delete GP.project;

                if (prjJson.own !== false) prj.savedId = prjJson.savedId;
                prj.savedPath = prjJson.savedPath;
                prj.savedIOSId = prjJson.savedIOSId;
                prj.title = prjJson.title;
                GP.setProject(prj);
                GPProjectView.initFromProject().then(function() {
                    GP.resetUndo();
                    GP.clearWaiting();
                    selectedItemSet.set([]);

                    if (get(mode) === "Plants")
                        GPContextItems.activate();
                    else
                        mode.set("Plants");

                    GPProjectView.onresize();
                    let evt = new CustomEvent('GPNewProject', {});
                    window.dispatchEvent(evt);
                    resolve();
                });

            } else {
                alert("This project cannot be reopened.");
                GP.clearWaiting();
            }
        });
    },

    saveToFile: async function() {
        await GP.doSaveToFile(false)
    },

    saveAsToFile: async function() {
        await GP.doSaveToFile(true)
    },

    doSaveToFile: async function(saveAs) {
        GP.showWaiting();
        try {
            let data = GP.project.jsonify(true, true, true, true);
            let res = await GPSettings.storageClass.saveToFile(data, saveAs, GP.project.savedPath);
            GP.project.unsavedChanges = false;
            unsavedChanges.set(false);
            GP.project.savedPath = res.path;
            GP.project.title = res.title;
            overwriteFileAvailable.set(GP.project.savedPath);
            if (GP.project.title) overwriteOnlineName.set(GP.project.title);
        } catch (e) {}
        GP.clearWaiting();
    },

    showWaiting: function() {
        GP.waitIndicator = true;
        $("#GPWaiting").show();
        GPProjectView.setCursor();
    },
    
    clearWaiting: function() {
        GP.waitIndicator = false;
        $("#GPWaiting").hide();
        GPProjectView.setCursor();
    },
    
    undo: function() {
        if (GP.undoStack.length === 0) return;

        let hash = GP.undoStack.pop();
        let prevdata = sessionStorage['GPUNDODATA' + hash];
        let prevtype = sessionStorage['GPUNDOTYPE' + hash];
        if (!prevdata || !prevtype) return;
        let dataParsed = JSON.parse(prevdata);

        if (prevtype === "background") {
            let ctx = GP.project.backgroundCanvas.getContext('2d');
            let img = new Image;
            img.onload = function(){
              ctx.filter = 'brightness(1) saturate(1) hue-rotate(0deg)';
              ctx.globalCompositeOperation = 'source-over';
              ctx.clearRect(0, 0, GP.project.backgroundCanvas.width, GP.project.backgroundCanvas.height);
              ctx.drawImage(img,0,0);
              $(document).trigger('GPBackgroundLoaded' );
              GPContextTexture.setFilter();
            };
            img.src = dataParsed;
        }

        if (prevtype === "surface") {
            let ctx = GP.project.textureCanvas.getContext('2d');
            let img = new Image;
            img.onload = function(){
              ctx.filter = 'brightness(1) saturate(1) hue-rotate(0deg)';
              ctx.globalCompositeOperation = 'source-over';
              ctx.clearRect(0, 0, GP.project.textureCanvas.width, GP.project.textureCanvas.height);
              ctx.drawImage(img,0,0);
              $(document).trigger('GPSurfaceLoaded' );
              GPContextTexture.setFilter();
            };
            img.src = dataParsed;
        }

        if (prevtype === "items") {
            dataParsed.surfaceData = GP.project.textureCanvas.toDataURL('image/webp');
            let prj = GPProject.parseFromJson(dataParsed, {
                "mode":"undo",
                "backgroundFromProject":GP.project
            });

            delete GP.project;
            GP.setProject(prj);
            GPProjectView.initFromProject();
        }

        if (prevtype === "addItem") {
            GP.project.removeItem(dataParsed.id);
            selectedItemSet.set([]);
        }
        if (prevtype === "addItems") {
            dataParsed.forEach(el => GP.project.removeItem(el.id));
            selectedItemSet.set([]);
        }
        if (prevtype === "modifyItems") {
            let plantHardRefreshRequired = false;
            dataParsed.forEach(el => {
                let item = GP.project.itemsById[el.id];
                item.x = el.x;
                item.y = el.y;
                item.scale = el.s;
                if (item.typeId !== el.typeId) {
                    plantHardRefreshRequired = true;
                    item.typeId = el.typeId;
                    item.data = GP.plantTypesById[item.typeId];
                }

                if (item.supportsFlip) item.horizontalFlip = el.f;
                if (item.supportsRotate) item.rotation = el.r;
                if (item.supportsAdjust) item.adjustment = el.adj ? el.adj : {
                    h: 0,
                    s: 0,
                    v: 0
                };

                if (item instanceof GPLabel) {
                    item.text = el.t;
                    $(document).trigger('GPLabelHardEdited', item);
                } else
                    $(document).trigger('GPItemHardEdited', item);
            })
            if (plantHardRefreshRequired) $(document).trigger('GPPlantsHardEdited');
        }
        if (prevtype === "deleteItems") {
            dataParsed.forEach(el => {
                if (el.type !== GPLabel.name) {
                    let itemInstance;
                    if (el.type === GPPlant.name)
                        itemInstance = GP.project.addPlant(el.itemInstance.typeId, el.itemInstance.x, el.itemInstance.y, el.itemInstance.s, el.itemInstance.id);
                    if (el.type === GPStructure.name || el.type === GPStructure3D.name)
                        itemInstance = GP.project.addStructure(el.itemInstance.typeId, el.itemInstance.x, el.itemInstance.y, el.itemInstance.s, el.itemInstance.f, el.itemInstance.adj, el.itemInstance.id, el.itemInstance.r);
                    if (el.type === GPCustomObject.name)
                        itemInstance = GP.project.addCustom(el.itemInstance.typeId, el.itemInstance.x, el.itemInstance.y, el.itemInstance.s, el.itemInstance.f, false, el.itemInstance.id);
                    GPContextItems.addItemInstanceToView(itemInstance);
                } else {
                    let originItemInstance = GP.project.itemsById[el.itemInstance.o];
                    let label = GP.project.addLabel(originItemInstance, el.itemInstance.t, el.itemInstance.x, el.itemInstance.y, el.itemInstance.id);
                    GPContextLabels.addLabelToView(label);
                }
            })
        }

        GP.project.unsavedChanges = true;
        unsavedChanges.set(true);
        delete sessionStorage['GPUNDODATA' + hash];
        delete sessionStorage['GPUNDOTYPE' + hash];
        GP.refreshUndo();
    },


    /**
     * Saves project state for potential undoing
     *
     * @param {"items"|"deleteItems"|"addItem"|"addItems"|"modifyItems"|"background"} type what is actually changed
     * @param {object=} data additional information (can be skipped for type = items)
     */
    saveUndo: function(type, data) {
        function freeOldest() {
            let oldesthash = GP.undoStack.shift();
            delete sessionStorage['GPUNDODATA' + oldesthash];
            delete sessionStorage['GPUNDOTYPE' + oldesthash];
        }
        let savedata;
        if (type === "items")
            savedata = GP.project.jsonify(false, false, type==="items", false);
        else
            savedata = JSON.stringify(data);

        let hash = new Date().getTime();
        if (GP.undoStack.length > 20) freeOldest();

        let saved = false;
        while (!saved) {
            try {
                sessionStorage['GPUNDODATA' + hash] = savedata;
                sessionStorage['GPUNDOTYPE' + hash] = type;
                saved = true;
            } catch (e) {
                if (GP.undoStack.length)
                    freeOldest();
                else {
                    console.log("unable to save undo");
                    return;
                }
            }
        }

        GP.undoStack.push(hash);
        GP.project.unsavedChanges = true;
        unsavedChanges.set(true);
        GP.refreshUndo();
    },
    
    resetUndo: function() {
        sessionStorage.clear()
        GP.undoStack = [];
        GP.refreshUndo();
    },
    
    refreshUndo: function() {
        undoAvailable.set(GP.undoStack.length > 0);
    },
    
    switchLargeTextMode: function () {
        GP.storeFocus();
        if ($('body').hasClass('GPLargeTextMode')) {
            $('body').removeClass('GPLargeTextMode');
            $('.GPLargeTextModeButton').text("Large text mode");
        } else {
            $('body').addClass('GPLargeTextMode');
            $('.GPLargeTextModeButton').text("Normal text mode");
        };
        GP.restoreFocus();
    },
        
    setProducts: function(prodList) {
        for (var i in prodList) {
            var prod = prodList[i];
            var prodName = prod["id"].split(".").pop();
            if (GPSettings.products[prodName])
                GPSettings.products[prodName].active = true;
        };
        GP.initApp();
    },

    storeFocus: function() {
        if ($(document.activeElement).parents('.GPMenuCog').length)
            GP.nextFocus = $('.GPMenuCog > button');
        else
            GP.nextFocus = $(document.activeElement);
    },

    restoreFocus: function() {
        if (GP.nextFocus) $(GP.nextFocus).focus();
    },

    zoomIn: function() {
        GP.viewZoom *= 1.2;
        GP.updateViewZoom();
    },

    zoomOut: function() {
        GP.viewZoom /= 1.2;
        GP.updateViewZoom();
    },

    zoomBy: function( step, centerX, centerY ) {
        var centerOnZoom = (GP.viewZoom < 3 && step > 0);

        GP.viewZoom += step;
        var sl = $('.GPDesignViewport').scrollLeft();
        var dw = $('.GPDesignViewport').innerWidth();
        var relX = (centerX - sl) / dw;
        var st = $('.GPDesignViewport').scrollTop();
        var dh = $('.GPDesignViewport').innerHeight();
        var relY = (centerY - st) / dh;

        GP.updateViewZoom();

        if (centerOnZoom) {
            $('.GPDesignViewport').scrollLeft(sl + relX * step * dw);
            $('.GPDesignViewport').scrollTop(st + relY * step * dh);
        }
    },

    zoomReset: function() {
        GP.viewZoom = 1;
        GP.updateViewZoom();
    },

    updateViewZoom: function() {
        if (GP.viewZoom < 1) GP.viewZoom = 1;
        if (GP.viewZoom > 3) GP.viewZoom = 3;

        if (GP.viewZoom < 1.05) GP.viewZoom = 1;
        if (GP.viewZoom === 1)
            $('.GPDesignViewport').css('overflow', 'initial');
        else
            $('.GPDesignViewport').css('overflow', 'scroll');


        GPProjectView.onresize();
    },

    
    preloaderSetProgress: function(perc) {
        $('.radial-progress').attr('data-progress', perc);
    },
    
    preloaderHide: function() {
        GP.preloaderSetProgress(90);
        setTimeout( function () {
            $('.preload').remove(); $('body').css('overflow','initial');
            $(document).trigger('GPAppStarted' );
        }, 700);

    },
    
    getParameterByName: function (name) {
        let searchParams = new URLSearchParams(window.location.search)
        return searchParams.get(name);
    },

    getCookieByName: function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    },
    
    removeSelectedItem() {
        GP.saveUndo("deleteItems", get(selectedItemSet).map( si => {return {itemInstance: si, type: si.constructor.name}} ));
        get(selectedItemSet).forEach(si => {
            GP.project.removeItem(si.id);
        })
        selectedItemSet.set([]);
    },

    biggerSelectedItem() {
        GP.saveUndo("modifyItems", get(selectedItemSet));
        get(selectedItemSet).forEach(si => {
            GP.project.biggerItem(si.id);
        })
    },

    smallerSelectedItem () {
        GP.saveUndo("modifyItems", get(selectedItemSet));
        get(selectedItemSet).forEach(si => {
            GP.project.smallerItem(si.id);
        })
    },

    rotateRightItem () {
        GP.saveUndo("modifyItems", get(selectedItemSet));
        get(selectedItemSet).forEach(si => {
            GP.project.rotateRightItem(si.id);
        })
    },

    rotateLeftItem () {
        GP.saveUndo("modifyItems", get(selectedItemSet));
        get(selectedItemSet).forEach(si => {
            GP.project.rotateLeftItem(si.id);
        })
    },

    flipSelectedItem() {
        GP.saveUndo("modifyItems", get(selectedItemSet));
        get(selectedItemSet).forEach(si => {
            GP.project.flipItem(si.id);
        })
    },

    cloneSelectedItem() {
        let addedItems = [];
        get(selectedItemSet).forEach(si => {
            let itemInstance = GP.project.cloneItem(si.id, GP.cloningOffset);
            if (itemInstance) {
                GPContextItems.addItemInstanceToView(itemInstance);
                addedItems.push(itemInstance);
            }
        })
        GP.saveUndo("addItems", addedItems);
        selectedItemSet.set(addedItems);
        GP.cloningOffset += 10;
    },

    cutSelectedItems() {
        GP.copySelectedItems();
        GP.removeSelectedItem();
    },

    copySelectedItems() {
        let data = {
            "plants": JSON.parse(GP.selectedItemsToSnippetData()),
            "reference": ({
                "designWidth": GP.project.designWidth,
                "horizonPos": GP.project.horizonPos,
                "sizeX": GP.project.sizeX,
                "sizeY": GP.project.sizeY
            })
        };

        navigator.clipboard.readText().then(() => {
            navigator.clipboard.writeText('x-gardenpuzzle-data:' + JSON.stringify(data));
        }).catch(err => {
            sessionStorage.setItem('x-gardenpuzzle-data', JSON.stringify(data));
        })
        GP.updatePastePossible();
    },

    pasteItems() {
        let paste = function (jsonData) {
            const data = JSON.parse(jsonData);
            let st = new GPTypeSnippet(data);
            GPContextItems.addSnippetAtDefaultPos(st)
        }
        navigator.clipboard.readText().then(clipText => {
            if (clipText.startsWith('x-gardenpuzzle-data:')) {
                const jsonData = clipText.substring('x-gardenpuzzle-data:'.length);
                paste(jsonData);
            }
        }).catch(err => {
            let clipText = sessionStorage.getItem('x-gardenpuzzle-data');
            if (clipText)
                paste(clipText);
        })
    },

    async updatePastePossible() {
        let clipText;
        let res = false;
        try {
            clipText = await navigator.clipboard.readText();
            res = clipText.startsWith('x-gardenpuzzle-data:');
        } catch (err) {
            clipText = sessionStorage.getItem('x-gardenpuzzle-data');
            res = !!clipText;
        }
        pasteAvailable.set(res);
        return res
    },

    swapItems() {
        let sis = get(selectedItemSet);
        let api = get(activePickerItem);
        if (sis.length === 1 && api && sis[0].typeId !== api.id)
            GP.project.swapItemsOfType(sis[0].typeId, api.id);

        if (sis.length > 1 && api) {
            GP.project.swapItems(sis, api.id);
        }
    },

    selectItemsByType(itemType) {
        selectedItemSet.set(GP.project.items.filter(i => itemType.id === i.typeId))
    },

    selectAllItems() {
        selectedItemSet.set([...GP.project.items]);
    }
}

